import { capitalizeString } from '../utils';
import { FONT_FAMILY } from './font-family';
import { FONT_SIZE, FONT_SIZE_TOKEN } from './font-size';
import { FONT_WEIGHT, FONT_WEIGHT_TOKEN } from './font-weight';
import { LETTER_SPACING } from './letter-spacing';
import { LINE_HEIGHT, LINE_HEIGHT_TOKEN } from './line-height';
// Build list of entries for type scales by combining tokens
const typeSpecScaleEntries = [];
FONT_SIZE_TOKEN.forEach((size) => {
    FONT_WEIGHT_TOKEN.forEach((weight) => {
        LINE_HEIGHT_TOKEN.forEach((lineHeight) => {
            typeSpecScaleEntries.push([
                `${size}_${weight}_${lineHeight}`,
                {
                    fontFamily: FONT_FAMILY.ARCHIVO[weight],
                    fontSize: FONT_SIZE[size],
                    fontWeight: FONT_WEIGHT[weight],
                    letterSpacing: LETTER_SPACING.NONE,
                    lineHeight: LINE_HEIGHT[`${size}_${lineHeight}`],
                },
            ]);
        });
    });
});
// Convert entries to a types object for official export
export const TYPE_SPEC_SCALE = Object.fromEntries(typeSpecScaleEntries);
// Declare type specs by mapping them to type scales
// Sorted here by hierarchy then by weight
const typeSpecMap = {
    TITLE_1: { SM: 'N_BOLD_DEFAULT', LG: 'R_BOLD_DEFAULT' },
    TITLE_2: { SM: 'M_BOLD_DEFAULT', LG: 'P_BOLD_DEFAULT' },
    TITLE_3: { SM: 'L_BOLD_DEFAULT', LG: 'N_BOLD_DEFAULT' },
    TITLE_4: { SM: 'K_BOLD_DEFAULT', LG: 'L_BOLD_DEFAULT' },
    TITLE_5: { SM: 'J_BOLD_DEFAULT', LG: 'K_BOLD_DEFAULT' },
    TITLE_6: { SM: 'H_BOLD_DEFAULT', LG: 'I_BOLD_DEFAULT' },
    SUBTITLE_1: { SM: 'H_SEMIBOLD_DEFAULT', LG: 'H_SEMIBOLD_DEFAULT' },
    SUBTITLE_2: { SM: 'G_SEMIBOLD_DEFAULT', LG: 'G_SEMIBOLD_DEFAULT' },
    SUBTITLE_3: { SM: 'F_SEMIBOLD_DEFAULT', LG: 'F_SEMIBOLD_DEFAULT' },
    BODY_CALLOUT: { SM: 'H_SEMIBOLD_LOOSE', LG: 'H_SEMIBOLD_LOOSE' },
    BODY_LARGE: { SM: 'H_REGULAR_DEFAULT', LG: 'H_REGULAR_DEFAULT' },
    BODY_LARGE_BOLD: { SM: 'H_BOLD_DEFAULT', LG: 'H_BOLD_DEFAULT' },
    BODY_LARGE_SEMIBOLD: { SM: 'H_SEMIBOLD_DEFAULT', LG: 'H_SEMIBOLD_DEFAULT' },
    BODY: { SM: 'G_REGULAR_DEFAULT', LG: 'G_REGULAR_DEFAULT' },
    BODY_SEMIBOLD: { SM: 'G_SEMIBOLD_DEFAULT', LG: 'G_SEMIBOLD_DEFAULT' },
    BODY_BOLD: { SM: 'G_BOLD_DEFAULT', LG: 'G_BOLD_DEFAULT' },
    BODY_2: { SM: 'F_REGULAR_LOOSE', LG: 'F_REGULAR_LOOSE' },
    BODY_2_SEMIBOLD: { SM: 'F_SEMIBOLD_LOOSE', LG: 'F_SEMIBOLD_LOOSE' },
    BODY_2_BOLD: { SM: 'F_BOLD_LOOSE', LG: 'F_BOLD_LOOSE' },
    MICRO: { SM: 'E_REGULAR_DEFAULT', LG: 'E_REGULAR_DEFAULT' },
    MICRO_BOLD: { SM: 'E_BOLD_DEFAULT', LG: 'E_BOLD_DEFAULT' },
    MICRO_SEMIBOLD: { SM: 'E_SEMIBOLD_DEFAULT', LG: 'E_SEMIBOLD_DEFAULT' },
};
// Build list of entries for type specsentries from map
const typeSpecEntries = Object.keys(typeSpecMap).map((key) => {
    const typeSpecScaleSm = typeSpecMap[key]
        .SM;
    const typeSpecScaleLg = typeSpecMap[key]
        .LG;
    return [
        key,
        {
            SM: TYPE_SPEC_SCALE[typeSpecScaleSm],
            LG: TYPE_SPEC_SCALE[typeSpecScaleLg],
        },
    ];
});
export const TYPE_SPEC = Object.fromEntries(typeSpecEntries);
export const getCFTypeSpec = (str) => {
    const strToken = str.toUpperCase();
    const match = Object.keys(TYPE_SPEC).find((key) => {
        return key.split('_').join('') === strToken;
    });
    if (match) {
        return TYPE_SPEC[match];
    }
    return TYPE_SPEC.BODY;
};
export const getCFTypeSpecName = (str) => {
    const parts = str.split('_');
    return parts.map((part) => capitalizeString(part.toLowerCase())).join('');
};
export const getCFTypeSpecScale = (str) => {
    const strToken = str.toUpperCase();
    const match = Object.keys(TYPE_SPEC_SCALE).find((key) => {
        return key.split('_').join('') === strToken;
    });
    if (match) {
        return TYPE_SPEC_SCALE[match];
    }
    return TYPE_SPEC_SCALE.G_REGULAR_DEFAULT;
};
